import { Module } from 'vuex';

import { ShiftCMSState } from '@/store';
import { UserLabel } from '@/models/label.model';
import labelsService from '@/services/labels.service';

export interface LabelsState {
  labels: UserLabel[];
}

export enum LabelsMutations {
  SetLabels = 'ls/SetLabels',
}

export enum LabelsActions {
  GetLabels = 'ls/GetLabels',
  AddLabel = 'ls/AddLabel',
  UpdateLabel = 'ls/UpdateLabel',
  DeleteLabel = 'ls/DeleteLabel',
}

const sn = (str: LabelsActions | LabelsMutations): string =>
  str.replace(/ls\//g, '');

export const labelsStore: Module<LabelsState, ShiftCMSState> = {
  namespaced: true,
  state: {
    labels: [],
  },
  mutations: {
    [sn(LabelsMutations.SetLabels)](state, labels: UserLabel[]) {
      state.labels = labels;
    },
  },
  actions: {
    async [sn(LabelsActions.GetLabels)]({ commit }) {
      const res = await labelsService.getList();
      if (res.status) {
        commit(sn(LabelsMutations.SetLabels), res.data);
      }
    },
    async [sn(LabelsActions.AddLabel)](_, label: UserLabel) {
      const res = await labelsService.create({
        ...label,
        id: undefined,
      });

      return res.status;
    },
    async [sn(LabelsActions.UpdateLabel)](_, label: UserLabel) {
      const res = await labelsService.edit(label);

      return res.status;
    },
    async [sn(LabelsActions.DeleteLabel)]({ dispatch }, id: number) {
      const res = await labelsService.delete(id);

      if (res.status) {
        dispatch(sn(LabelsActions.GetLabels));
      }
    },
  },
};
